import { Link } from "wouter";
import { ChevronLeft } from "lucide-react";

interface BackBarProps {
  /** The URL to navigate back to */
  href: string;
  /** Human-readable label, e.g. "Dashboards" or "Cadence Queue" */
  label: string;
}

export function BackBar({ href, label }: BackBarProps) {
  return (
    <div className="max-w-[1400px] mx-auto px-6 pt-4 pb-0">
      <Link
        href={href}
        className="inline-flex items-center gap-1.5 text-[13px] text-muted-foreground hover:text-foreground transition-colors"
      >
        <ChevronLeft className="w-3.5 h-3.5" />
        {label}
      </Link>
    </div>
  );
}
